<template id="car-calculator">
  <section
    class="calculator_car-number"
    :class="{'blur-active': isFetching}"
  >
    <div class="blur" />

    <div class="flex-columns-holiday">
      <div
        class="calculator__block_car-number"
        v-if="!isHoliday"
      >
        <div class="block_car-number">
          <div
            v-if="withHoles"
            class="block__dot_hole block__dot_left"
          />
          <div class="block__grid">
            <div class="grid__column grid__column--first">
              <div class="column__text">
                <div
                  v-for="(symbol, index) in primarySymbols"
                  :key="index"
                  :class="getSymbolCss('text__symbol', calculator[symbol.type][symbol.order], symbol.type)"
                >
                  <span class="symbol__value">{{ getSymbolValue(symbol) }}</span>
                  <div class="symbol__select">
                    <SymbolSelect
                      v-model="calculator[symbol.type][symbol.order]"
                      :list="symbols[symbol.type]"
                      @change="saveCalculatorToStorage"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="grid__column grid__column--second">
              <div class="column__block">
                <div :class="getSymbolCss('column__text_region-code', calculator.region.code)">
                  {{ getSymbolValue({type: 'region', order: 'code'}) }}
                </div>
                <div class="column__footer">
                  <div class="footer__text">
                    RUS
                  </div>
                  <div
                    v-if="withFlag"
                    class="footer__image"
                  >
                    <img
                      src="@/app/assets/flag.jpg"
                      class="image__elem"
                    >
                  </div>
                </div>
              </div>
              <div class="block__select">
                <SymbolSelect
                  v-model="calculator.region.code"
                  dropdown-min-width="73px"
                  :list="regionsCodesList"
                  @change="saveCalculatorToStorage"
                />
              </div>
            </div>
          </div>
          <div
            v-if="withHoles"
            class="block__dot_hole block__dot_right"
          />
        </div>
        <div class="block__select_region">
          <RegionSelect
            v-model="calculator.region.location"
            @change="handleLocationChange"
          />
        </div>
      </div>
      <div
        class="calculator__block_car-number holiday"
        v-if="isHoliday"
      >
        <div
          class="price-wrapper"
        >
          <div class="price">
            {{price}} ₽/шт
          </div>
          <div
            class="buy"
            v-if="windowWidth <= 850 || (windowWidth > 990 && windowWidth <= 1150)"
          >
            <div
              class="buy-counter"
            >
              <span
                class="buy-action"
                @click="counter = counter === 1 ? counter : counter - 1"
              >
                <i
                  class="buy-minus-icon"
                  aria-hidden="true"
                >
                  <svg
                    width="11"
                    height="1"
                    viewBox="0 0 11 1"
                  >
                    <rect
                      width="11"
                      height="1"
                      rx="0.5"
                      ry="0.5"
                    /></svg></i>
              </span>
              <input
                class="buy-input"
                type="text"
                :value="counter"
              >
              <span
                @click="counter = counter + 1;"
                class="buy-action"
              ><i
                class="buy-plus-icon"
                aria-hidden="true"
              ><svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
              ><path
                d="M1034.5,193H1030v4.5a0.5,0.5,0,0,1-1,0V193h-4.5a0.5,0.5,0,0,1,0-1h4.5v-4.5a0.5,0.5,0,0,1,1,0V192h4.5A0.5,0.5,0,0,1,1034.5,193Z"
                transform="translate(-1024 -187)"
              /></svg></i></span>
            </div>
            <div
              class="buy-button"
              @click="fetchCar"
            >
              В корзину
            </div>
            <div
              class="toster"
              v-if="toster"
            >
              {{ toster }}
            </div>
          </div>
        </div>

        <div class="block_car-number">
          <div
            v-show="withHoles"
            class="block__dot_hole block__dot_left"
          />
          <div
            class="block__grid"
            :style="backgroundTextBorderStyling"
          >
            <div
              class="grid__column grid__column--first"
              :class="{'grid__column--first_region': !withRegion}"
            >
              <div class="flex-column">
                <div
                  contenteditable="true"
                  class="holiday-show"
                  :class="{'holiday-show-region ': withRegion}"
                  @input="validate($event, 'all', 'main_text')"
                  :style="`${locationPosition}`"
                  ref="mainTextInput"
                />
              </div>
            </div>
            <div
              class="grid__column grid__column--second"
              :style="`border-color: ${this.holiday.selectedTextColor}`"
              v-if="withRegion"
            >
              <div class="column__block">
                <p class="column__text_region-code">
                  <input
                    v-if="withRegion"
                    @input="validate($event, 'numbers', 'upper_text')"
                    maxlength="3"
                    v-model="holiday.upper_text"
                  >
                </p>
              </div>
              <div class="column__footer">
                <p class="footer__text">
                  <select
                    v-if="withRegion"
                    @input="holiday.bottom_text = $event.target.value;"
                  >
                    <option
                      v-for="option in holiday.bottom_text_options"
                      :key="option"
                      class="select-option"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                  <svg
                    class="arrow-icon arrow-icon-active"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.94553 3H6.26253L12 8.12085L11.1036 9L6 4.50083L0.8964 9L0 8.12085L5.73747 3H5.94553Z"
                      fill="black"
                    />
                  </svg>
                </p>
              </div>
            </div>
          </div>
          <div
            v-show="withHoles"
            class="block__dot_hole block__dot_right"
          />
        </div>
        <div class="error">
          {{ error ? error : '' }}
        </div>
        <div class="checkers segment">
          <div
            class="crop-title colorize-switch faded"
            @click="regionSwitch"
          >
            <div class="calculator__text">
              С регионом / без
            </div>
            <input
              class="input-checkbox"
              type="checkbox"
              :checked="withRegion"
            >
          </div>
          <div
            class="crop-title colorize-switch faded"
            @click="withHoles = !withHoles"
          >
            <div class="calculator__text">
              С отверстиями / без
            </div>
            <input
              class="input-checkbox"
              type="checkbox"
              :checked="withHoles"
            >
          </div>
        </div>
      </div>
      <div
        v-if="isHoliday"
        class="flex-column-controls"
      >
        <div
          class="buy"
          v-if="windowWidth > 850 && !(windowWidth > 990 && windowWidth < 1151)"
        >
          <div
            class="buy-counter"
          >
            <span
              class="buy-action"
              @click="counter = counter === 1 ? counter : counter - 1"
            >
              <i
                class="buy-minus-icon"
                aria-hidden="true"
              >
                <svg
                  width="11"
                  height="1"
                  viewBox="0 0 11 1"
                >
                  <rect
                    width="11"
                    height="1"
                    rx="0.5"
                    ry="0.5"
                  /></svg></i>
            </span>
            <input
              class="buy-input"
              type="text"
              :value="counter"
            >
            <span
              @click="counter = counter + 1;"
              class="buy-action"
            ><i
              class="buy-plus-icon"
              aria-hidden="true"
            ><svg
              width="11"
              height="11"
              viewBox="0 0 11 11"
            ><path
              d="M1034.5,193H1030v4.5a0.5,0.5,0,0,1-1,0V193h-4.5a0.5,0.5,0,0,1,0-1h4.5v-4.5a0.5,0.5,0,0,1,1,0V192h4.5A0.5,0.5,0,0,1,1034.5,193Z"
              transform="translate(-1024 -187)"
            /></svg></i></span>
          </div>
          <div
            class="buy-button"
            @click="fetchCar"
          >
            В корзину
          </div>
          <div
            class="toster"
            v-if="toster"
          >
            {{ toster }}
          </div>
        </div>
        <div
          class="colorizing segment"

        >
          <div
            class="colorize-background"

          >
            <div class="calculator__text">
              Цвет фона:
            </div>
            <div
              class="colorize-pallet"
            >
              <div
                v-for="color in holiday.pallet_background"
                :key="color"
                @click="holiday.selectedBackgroundColor === color ? holiday.selectedBackgroundColor = '#d8d8d8' : holiday.selectedBackgroundColor = color"
                class="colorize-color"
                :class="{'colorize-color-active': holiday.selectedBackgroundColor === color}"
                :style="palletColor(color)"
              />
            </div>
          </div>
          <div class="colorize-text">
            <div class="calculator__text">
              Цвет текста и рамки:
            </div>
            <div
              class="colorize-pallet"
              v-if="holiday.hide_color_text"
            >
              <div
                v-for="color in holiday.pallet_word"
                :key="color"
                @click="holiday.selectedTextColor === color ? holiday.selectedTextColor = '#2F3441' : holiday.selectedTextColor = color"
                class="colorize-color"
                :class="{'colorize-color-active': holiday.selectedTextColor === color}"
                :style="palletColor(color)"
              />
            </div>
          </div>
        </div>
        <div class="location segment">
          <div class="calculator__text">
            Расположение текста:
          </div>
          <div class="location-items">
            <div
              class="location-item"
              @click="holiday.selectedLocation = 1"
              :class="{'location-item-active': holiday.selectedLocation === 1}"
            >
              <input
                type="radio"
                :name="`radio-${this._uid}`"
                value="1"
                :checked="holiday.selectedLocation === 1"
              >
              <div class="location-content">
                <div class="location-left location-icon">
                  <div />
                  <div />
                  <div />
                </div>
                <span>слева</span>
              </div>
            </div>
            <div
              class="location-item"
              @click="holiday.selectedLocation = 2"
              :class="{'location-item-active': holiday.selectedLocation === 2}"
            >
              <input
                type="radio"
                :name="`radio-${this._uid}`"
                value="2"
                :checked="holiday.selectedLocation === 2"
              >
              <div class="location-content">
                <div class="location-center location-icon">
                  <div />
                  <div />
                  <div />
                </div>
                <span>по центру</span>
              </div>
            </div>
            <div
              class="location-item"
              @click="holiday.selectedLocation = 3"
              :class="{'location-item-active': holiday.selectedLocation === 3}"
            >
              <input
                type="radio"
                :name="`radio-${this._uid}`"
                value="3"
                :checked="holiday.selectedLocation === 3"
              >
              <div class="location-content">
                <div class="location-right location-icon">
                  <div />
                  <div />
                  <div />
                </div>
                <span>справа</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import regions from '@/constants/regions';
import dictionary from '@/constants/dictionary.json';

const symbols = {
  numbers: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  letters: ['А', 'В', 'Е', 'К', 'М', 'Н', 'О', 'Р', 'С', 'Т', 'У', 'Х'],
};
const STORAGE_KEY = 'savedCalculator';
export default {
  template: '#car-calculator',
  props: {
    withFlag: {
      type: Boolean,
      default: false,
    },
    isHoliday: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toster: '',
      withRegion: true,
      withHoles: false,
      error: null,
      counter: 1,
      isFetching: false,
      windowWidth: window.innerWidth,
      openDrugAndDrop: false,
      holiday: {
        main_text: 'Удача',
        count_main_text: {},
        upper_text: '40',
        bottom_text: window.bottom_text || 'ЛЕТ',
        bottom_text_options: window.bottom_text_options || ['ЛЕТ', 'ГОДА', 'ГОД'],
        selectedLocation: 2,
        hide_color_text: true,
        hide_color_background: true,
        selectedTextColor: '#2F3441',
        selectedBackgroundColor: '#d8d8d8',
        pallet_background: window.customAppZnak2color2 ?? ['rgb(225, 43, 42)', 'rgb(23, 22, 27)', 'rgb(9, 38, 156)', 'rgb(221, 222, 257)', 'rgb(245, 202, 9)', 'rgb(5, 157, 116)'],
        pallet_word: window.customAppZnak2color1 ?? ['white', 'rgb(23, 22, 27)', 'rgb(9, 38, 156)', 'rgb(225, 43, 42)', 'rgb(255, 215, 0)', 'silver'],
        lengthOfRegion: 360,
        lengthWithoutRegion: 495,
      },
      calculator: {
        letters: {
          first: 'A',
          second: 'A',
          third: 'A',
        },
        numbers: {
          first: '0',
          second: '0',
          third: '0',
        },
        region: {
          location: '',
          code: '01',
        },
      },
    };
  },
  created() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', ()=>{
      this.windowWidth = window.innerWidth;

    });
  },
  mounted() {
    this.getValuesFromStorage();
    this.$refs.mainTextInput.innerHTML = this.updatedMainText.toString();

  },
  watch: {
    error(value){
      if(value){
        setTimeout(()=>{
          this.error = null;
        }, 5000);
      }
    },
    'holiday.main_text'(value) {
      this.$refs.mainTextInput.innerHTML = this.updatedMainText.toString();
    },
    toster(value) {
      if (value) {
        setTimeout(() => {
          this.toster = '';
        }, 5000);
      }
    }
  },
  computed: {
    price(){
      return window.priceSku1 || window.priceSku2;
    },
    locationPosition() {
      if (this.holiday.selectedLocation === 1) {
        return 'text-align: left;';
      }
      if (this.holiday.selectedLocation === 2) {
        return 'text-align: center;';
      }
      if (this.holiday.selectedLocation === 3) {
        return 'text-align: right;';
      }
      return '';
    },
    primarySymbols() {
      return [
        {
          type: 'letters',
          order: 'first',
        },
        {
          type: 'numbers',
          order: 'first',
        },
        {
          type: 'numbers',
          order: 'second',
        },
        {
          type: 'numbers',
          order: 'third',
        },
        {
          type: 'letters',
          order: 'second',
        },
        {
          type: 'letters',
          order: 'third',
        },
      ];
    },
    regionsCodesList() {
      const currentLocation = this.calculator.region.location;
      return this.regions[currentLocation]?.codes ?? this.allRegionsCodes;
    },
    allRegionsCodes() {
      let results = [];
      for (const regionKey in this.regions) {
        const region = this.regions[regionKey];
        results = [...results, ...region.codes];
      }
      return results;
    },
    regions() {
      return regions;
    },
    symbols() {
      return symbols;
    },
    backgroundTextBorderStyling() {
      let background = this.holiday.selectedBackgroundColor;

      return `background: ${background};
      color: ${this.holiday.selectedTextColor};
      border: 4px solid ${this.holiday.selectedTextColor};`;
    },
    updatedMainText() {
      let word = this.holiday.main_text.split('').length ? this.holiday.main_text.split('') : [''];

      for (let i = 0; i < word.length; i++) {
        if (word[i] === '') {
          word[i] = '<span class="empty"></span>';
        } else if ((word[i] === word[i].toLowerCase()) && (word[i].toUpperCase() !== word[i].toLowerCase())) {
          word[i] = `<span class='lower'>${word[i].toUpperCase()}</span>`;
        } else if (word[i] === ' ') {
          word[i] = '<span class=\'upper space\'>&nbsp;</span>';
        } else {
          word[i] = `<span class='upper'>${word[i].toUpperCase()}</span>`;
        }
      }
      word = word.join('');

      return word;
    }
  },
  methods: {
    async fetchCar() {
      try {
        this.isFetching = true;
        const data = await fetch('https://znak.ru/_custom/code/preprocss/customznak/add2cart/', {
          method: 'POST',
          body: JSON.stringify({
            counter: this.counter,
            text: this.holiday.main_text,
            text_position: this.holiday.selectedLocation,
            region: this.holiday.upper_text,
            regionText: this.holiday.bottom_text,
            withHoles: this.withHoles,
            withRegion: this.withRegion,
            symbolColor: this.holiday.selectedTextColor,
            backgroundColor: this.holiday.selectedBackgroundColor,

          }),
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (data.status === 200) {
          this.toster = 'Товар успешно добавлен в корзину!';
        } else {
          this.toster = 'Что-то пошло не так. Попробуйте позже.';
        }
      } catch (e) {
        this.toster = 'Что-то пошло не так. Попробуйте позже.';
      } finally {
        this.counter = 1;
        this.holiday.main_text = 'Удача';
        this.holiday.upper_text = '40';
        this.holiday.bottom_text = 'ЛЕТ';
        this.holiday.withHoles = false;
        this.holiday.withRegion = true;
        this.holiday.selectedTextColor = '#2F3441';
        this.holiday.selectedBackgroundColor = '#d8d8d8';
        this.holiday.selectedLocation = 2;

        this.error = null;
        setTimeout(()=>{
          this.isFetching = false;
        }, 1000);
      }
    },
    regionSwitch() {
      this.withRegion = !this.withRegion;
      const event = {target: {innerHTML: this.updatedMainText}};
      this.validate(event, 'all', 'main_text');
    },
    palletColor(color) {
      if (!color) {
        return '';
      }
      return `background: ${color}`;
    },
    //calculate quantity of each symbol in string
    updateCharCounts() {
      this.holiday.count_main_text = {};
      for (let char of this.holiday.main_text) {
        if (char === ' ') {
          char = 'space';
        }
        if (char in this.holiday.count_main_text) {
          this.holiday.count_main_text[char]++;
        } else {
          this.holiday.count_main_text[char] = 1;
        }
      }
    },
    mask(type) {
      if (type === 'all') {
        return /[^a-zA-Zа-яА-Я 0-9\s\.\-\+@\"\=\Ʊ]/g;
      }
      if (type === 'numbers') {
        return /[^0-9]/g;
      }
      if (type === 'symbols') {
        return /[^A-ZА-Я]/g;
      }

      return '';
    },
    letter_size_check(letter){
      if ((letter === letter.toLowerCase()) && (letter.toUpperCase() !== letter.toLowerCase())) {
        return letter.toLowerCase();
      } else {
        return letter.toUpperCase();
      }
    },
    main_text_editing(value) {
      let letters = [];
      const parser = new DOMParser();

      const doc = parser.parseFromString(value, 'text/html');
      const spans = doc.querySelectorAll('span');
      spans.forEach((span, index) => {
        let letter = span.textContent;
        letter = letter.replace(/[\s\u00A0]/g, ' ');
        letter = letter.replace(this.mask('all'), '');
        if (letter.length > 1) {
          if (index === 0 && spans.length === 1) {
            letters.push(span.classList.contains('upper') ? letter[0].toUpperCase() : letter[0].toLowerCase());
            letters.push(letter[1]);
          } else if (index === 0) {
            letters.push(this.letter_size_check(letter[0]));
            letters.push(span.classList.contains('upper') ? letter[1].toUpperCase() : letter[1].toLowerCase());
          } else {
            letters.push(span.classList.contains('upper') ? letter[0].toUpperCase() : letter[0].toLowerCase());
            letters.push(letter[1]);
          }
        } else {
          if (span.classList.contains('upper')) {
            letters.push(letter.toUpperCase());
          }
          if (span.classList.contains('lower')) {
            letters.push(letter.toLowerCase());
          }
          if (span.classList.contains('empty')) {
            if ((letter === letter.toLowerCase()) && (letter.toUpperCase() !== letter.toLowerCase())) {
              letters.push(letter.toLowerCase());
            } else {
              letters.push(letter.toUpperCase());
            }
          }


        }

      });
      this.holiday.main_text = letters.join('');

      this.updateCharCounts();
      let lengthOf = 0;
      const maxLength = this.withRegion ? this.holiday.lengthOfRegion : this.holiday.lengthWithoutRegion;
      for (let letter of this.holiday.main_text) {
        if (letter === ' ') {
          letter = 'space';
        }
        if (this.holiday.count_main_text[letter] > dictionary[letter].max_quantity) {
          if (letter === 'space') {
            letter = ' ';
          }
          let index = this.holiday.main_text.lastIndexOf(letter);
          this.holiday.main_text = this.holiday.main_text.slice(0, index) + this.holiday.main_text.slice(index + 1);
          let symbol = letter;
          if(symbol === ' '){
            symbol = 'Пробел';
          }
          this.error = `Достигнут лимит символа ${symbol}`;
          this.updateCharCounts();
          this.$refs.mainTextInput.innerHTML = this.updatedMainText.toString();

          return;
        } else {
          this.error = null;
        }
      }
      for (let letter of this.holiday.main_text) {
        if (letter === ' ' || /\s/g.test(letter)) {
          letter = 'space';
        }
        lengthOf += dictionary[letter].width;
        if (lengthOf > maxLength) {
          this.error = 'Данный символ не помещается';
          this.holiday.main_text = this.holiday.main_text.slice(0, this.holiday.main_text.length - 1);
          lengthOf -= dictionary[letter].width;
        } else {
          this.error = null;
        }
      }


      this.$refs.mainTextInput.innerHTML = this.updatedMainText.toString();
    },
    validate(event, type, variable) {
      if (variable === 'main_text') {
        this.main_text_editing(event.target.innerHTML);
        this.$nextTick(() => {
          const input = this.$refs.mainTextInput;
          input.focus();
          const range = document.createRange();
          range.selectNodeContents(input);
          range.collapse(false);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        });
        return;
      }
      if (variable === 'upper_text' && this.holiday[variable] === '') {
        setTimeout(()=>{
          if(this.holiday[variable] === '') {
            this.holiday[variable] = '0';
          }
        }, 1000);
      }
      this.holiday[variable] = this.holiday[variable].toUpperCase();
      const allowedChars = this.mask(type);
      this.holiday[variable] = this.holiday[variable].replace(allowedChars, '');


    },
    getSymbolCss(primaryClass, calculatorValue = '*', type = 'regions') {
      return [primaryClass, `${type}-symbol`, {
        'active-symbol': !!(calculatorValue !== '*'),
      }];
    },
    getSymbolValue({type, order}) {
      const fallbackValues = {
        letters: {
          first: 'A',
          second: 'A',
          third: 'A',
        },
        numbers: {
          first: '0',
          second: '0',
          third: '0',
        },
        region: {
          code: '01',
        },
      };
      const fallback = fallbackValues[type][order];
      const calculatorValue = this.calculator[type][order];
      return calculatorValue === '*' ? fallback : calculatorValue;
    },
    getValuesFromStorage() {
      const savedValues = localStorage.getItem(STORAGE_KEY);
      if (savedValues) {
        const parsedState = JSON.parse(savedValues);
        this.calculator = {
          ...parsedState
        };
      }
    },
    handleLocationChange() {
      this.calculator.region.code = '*';
      this.$nextTick(this.saveCalculatorToStorage);
    },
    saveCalculatorToStorage() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.calculator));
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'Russian Road Sign';
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url("@/app/assets/russianroadsign_medium.otf") format('opentype');
}

.flex-column {
  width: 100%;
}

.flex-columns-holiday {
  display: flex;
  flex-direction: row;
  gap: 50px;
  @media (max-width: 1150px) {
    flex-direction: column;
    gap: 0;
  }
  @media (max-width: 990px) {
    flex-direction: row;
    gap: 50px;
  }
  @media (max-width: 850px) {
    flex-direction: column;
    gap: 0;
  }
}

.flex-column-controls {
  max-width: 400px;
  width: 100%;
}

.calculator_car-number {
  font-family: 'Montserrat';
  position: relative;
}


.calculator_car-number .calculator__text {
  font-family: 'Montserrat';
  font-size: 20px;
  line-height: 22px;
  padding: 0;
  margin: 0;
}

.calculator_car-number .calculator__block_car-number {
  margin-top: 40px;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
}
.clip-icon {
  width: 20px;
  color: black;
  transition: .3s ease all;
}
.calculator__block_car-number .block__dot_hole {
  position: absolute;
  top: 48%;
  width: 6px;
  height: 6px;
  background-color: #fff;
  border-radius: 50%;
  border: 1px #000 solid;
}

.calculator__block_car-number .block__dot_left {
  left: 8px;
}

.calculator__block_car-number .block__dot_right {
  right: 8px;
}
.grey-rectangle {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: black;
  opacity: .3;
}
.calculator_car-number .block__select_region {
  margin-left: 25px;
}

.calculator_car-number .column__text_region-code,
.calculator_car-number .symbol__value {
  transition: opacity 0.3s;
  opacity: 0.3;
}

.calculator_car-number .active-symbol,
.calculator_car-number .active-symbol .symbol__value {
  opacity: 1;
}

.calculator_car-number .column__block {
  position: relative;
}

.calculator_car-number .block_car-number {
  box-shadow: -5px 1px 30px 1px rgba(34, 60, 80, 0.6);
  width: 380px;
  position: relative;
  border-radius: 8px;

}
.holiday .block_car-number {
  width: 400px;
}
.calculator_car-number .block__grid {
  display: grid;
  grid-template-columns: 1fr auto;
  border-radius: 8px;
  background: #D8D8D8;
  color: #2F3441;
  font-family: 'Inter';
  min-height: 81px;
  max-height: 81px;
  border: 4px solid black;
}

.calculator_car-number .grid__column {
  border-radius: 4px;
}

.calculator_car-number .grid__column--first {
  display: flex;
  align-items: center;
  padding: 0;
  padding-left: 3px;
}


.calculator_car-number .grid__column--second {
  padding: 0 8px;
}

.calculator_car-number .column__text {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  column-gap: 2px;
  align-items: center;
  font-family: inherit;
  font-size: 65px;
  line-height: normal;
  color: #2F3441;
  font-weight: 500;
  padding: 0;
  margin: 0;
}

.calculator_car-number .text__symbol {
  position: relative;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: end;
}

.calculator_car-number .numbers-symbol {
  line-height: 1;
}

.calculator_car-number .letters-symbol {
  font-size: 42px;
}

.calculator_car-number .symbol__select,
.calculator_car-number .block__select {
  position: absolute;
  width: 100%;
}

.calculator_car-number .symbol__select {
  top: 85.5px;
}

.calculator_car-number .block__select {
  top: 94px;
}

.calculator_car-number .column__footer {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  text-align: center;
}

.calculator_car-number .column__text_region-code {
  font-size: 40px;
  font-weight: 500;
  letter-spacing: -0.05em;
  line-height: 46px;
  margin: 0;
}

.calculator_car-number .footer__text {
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.05em;
  margin: 0;
  width: 100%;
}

.calculator_car-number .grid__column--second {
  min-width: 100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-left: 4px solid black;
  border-radius: 0;
}

.calculator_car-number .footer__image {
  display: flex;
  width: 31px;
  height: 20px;
  margin-left: 8.5px;
}
.faded {
  transition: all .3s ease;
  &:hover {
    color: #365EDC;
    svg {
      color: #365EDC;
    }
  }

}
.calculator_car-number .image__elem {
  object-fit: contain;
  width: inherit;
  height: inherit;
}
.cancel-icon {
  width: 20px;
  height: 22px;
  position: relative;
  cursor: pointer;
  div {
    &:nth-child(1){
      transform: rotate(-45deg);
    }
    width: 3px;
    height: 23px;
    transform: rotate(45deg);
    background: #d32222;
    position: absolute;
    top: 0;
    left: 8px;
  }
}
.crop-controls {
  margin-top: 10px;
  @media (min-width: 851px) {
    margin-top: 0;
  }
  @media (min-width: 990px) {
    margin-top: 10px;
  }
  @media (min-width: 1150px) {
    margin-top: 0;
  }
}
.cancel-crop {
  margin-left: auto;
  margin-bottom: 7px;
}
.cancel-drag {
  position: absolute;
  top: 10px;
  right: 10px;
}
@media (max-width: 767px) {
  .calculator_car-number .calculator__block_car-number {
    flex-direction: column-reverse;
    align-items: flex-start;
  }

  .calculator_car-number .block__select_region {
    margin: 0 0 25px 0;
  }
}

.holiday-show[contenteditable] {
  text-transform: none;
}

.holiday .grid__column--first {
  max-width: 302px;
  min-width: 302px;
}

.holiday .grid__column--second {
  max-height: 76px;
  overflow: hidden;
  justify-content: unset;
  padding: 0 5px;
  min-width: 90px;
}
.holiday {
  max-width: 400px;
  width: 100%;
}
.segment {
  padding: 10px;
  border: 1px solid #555555;
  border-radius: 7px;
  max-width: 400px;
  width: 100%;
}
.x-drag-and-drop-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.holiday-show {
  white-space: nowrap;
  text-transform: none;
  height: 100%;
  outline: none;
  border: none;
  overflow: hidden;
  max-height: 76px;
  vertical-align: bottom;
  line-height: 100px;

  span {
    display: inline-block;
  }

  .empty {
    min-height: 76px;
  }

  .lower {
    font-size: 39px;
    font-weight: 600;
    line-height: 93px;
    letter-spacing: -0.01em;
  }

  .upper {
    font-size: 60px;
    font-weight: 500;
    line-height: 77px;
    letter-spacing: -0.04em;
  }

  .space {
    font-size: 57px;
  }
}

.holiday .block__grid {
  font-family: 'Inter';
}

.holiday-inputs {
  display: flex;
  margin-top: 20px;
  width: 100%;
  gap: 10px;

}

.holiday-input {
  width: 100%;
  height: 100%;
  outline: none;
  border: 1px solid #d8d8d8;
  padding: 10px 24px;
  font-size: 25px;
  color: #2F3441;
  font-family: inherit;

}

.calculator_car-number .holiday {
  display: block;
}
.price-wrapper {
  margin-bottom: 30px;
}
.price {
  font-weight: 700;
  font-size: 26px;
  color: #555555;
  text-align: right;
}
.holiday .column__text_region-code {
  opacity: 1;
  font-size: unset;
  font-weight: unset;
  letter-spacing: unset;
  line-height: unset;
  input {
    outline: none;
    border: none;
    font-size: 43px;
    line-height: 48px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    background: transparent;
    width: 100%;
    color: inherit;
    max-width: 77px;
    text-align: center;
    font-family: inherit;
    letter-spacing: -0.05em;

  }
}


.location-items {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 24px;
  gap: 30px;
}

.location-item {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  gap: 5px;

  input {
    align-self: flex-start;
    width: 16px;
    height: 16px;
    margin: 0;
    margin-right: 5px;
    cursor: pointer;
  }

  span {
    color: #000;
  }


}


.location-icon {

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 7px;
  max-width: 24px;
  width: 100%;

  div {
    width: 100%;
    background: #000;
    height: 2px;
  }
}

.location-left div {
  &:nth-child(2) {
    width: 70%;
  }
}

.location-center {
  align-items: center;

  div {
    &:nth-child(2) {
      width: 85%;
    }

    &:nth-child(3) {
      width: 70%;
    }
  }
}

.location-right {
  align-items: flex-end;

  div {
    &:nth-child(2) {
      width: 70%;
    }
  }
}

.location-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.location-item-active {
  .location-content {
    span {
      color: #365EDC;
    }

    .location-icon div {
      background: #365EDC;
    }
  }
}

.holiday .footer__text {
  position: relative;
  cursor: pointer;

  svg {
    display: none;
    position: absolute;
    top: 5px;
    right: -2px;
  }

  select {
    cursor: pointer;
    font-family: inherit;
    font-weight: 600;
    color: inherit;
    outline: none;
    border: none;
    font-size: 24px;
    line-height: 22px;
    width: 100%;
    background-color: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    text-align: center;
  }

  select::-ms-expand {
    display: none;
  }

  &:hover {
    select {
      opacity: 0.75;
    }

    svg {
      display: block;
      opacity: 0.45;
    }
  }

}

.colorizing {
  margin-top: 11px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.colorize-switch {
  display: flex;
  max-width: 400px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.colorize-switch-disabled {
  cursor: default;
  opacity: 0.3;
}

.arrow-icon {
}

.arrow-icon-active {
  transform: rotate(180deg);
}

.colorize-color {
  width: 24px;
  height: 24px;
  border: 1px solid #d8d8d8;
}

.colorize-pallet {
  margin-top: 20px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.colorize-color {
  cursor: pointer;
  position: relative;
}

.colorize-color-active {
  border-color: #000;

  &:before {
    content: "";
    display: block;
    width: 11px;
    height: 2px;
    transform: rotate(45deg);
    position: absolute;
    background: rgb(0, 0, 0);
    top: 13px;
    left: 2px;
  }

  &:after {
    content: "";
    display: block;
    width: 18px;
    height: 2px;
    transform: rotate(125deg);
    position: absolute;
    background: rgb(0, 0, 0);
    top: 10px;
    left: 7px;
  }
}
.select-option {
  color: black;
}
.colorize-text {
}

.error {
  color: red;
  height: 18px;
  margin-top: 20px;
}

.crop-title {
  margin-top: 40px;

  input {
    cursor: pointer;
  }
}
.buy {
  display: flex;
  //flex-wrap: wrap;
  //justify-content: space-between;
  //align-items: stretch;
  //padding-top: 30px;
}
.buy-counter {
  //max-width: 45%;
  //flex-grow: 1;
  //position: relative;
  //margin-bottom: 15px;
  //display: flex;
}
.buy-action {
  //max-width: 45px;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  //text-align: center;
  //font-size: 20px;
  //padding: 0 10px;
  //cursor: pointer;
}
.buy-button {
  //max-width: 45%;
  //flex-grow: 1;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  //text-transform: uppercase;
  //margin-bottom: 15px;
  //cursor: pointer;
  //background-color: #365edc;
  //border-color: #365edc;
  //color: #ffffff;
  //padding: 14px 3px;
}
.buy-input {
  //max-width: 45px;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  //text-align: center;
  //font-size: 20px;
}
.x-drag-and-drop {
  border: 3px solid #d8d8d8;
  border-radius: 7px;
  display: flex;
  z-index: 1;
  background: white;
  max-width: 550px;
  width: 100%;
  height: 200px;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
}

.x-drag-and-drop-button {
  cursor: pointer;
  font-size: 19px;
  &:hover {
    color: #365EDC;
  }
}


.checkers {
  margin-top: 27px;
}
.location-item {
  input[type="radio"] {
    appearance: none;
    border: 2px solid #A5A7AB;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:after {
      content: '';
      display: none;
      border-radius: 50%;
      width: 10px;
      height: 10px;
      background: #365EDC;
    }
  }

  input[type="radio"]:checked {
    border-color: #365EDC;

    &:after {
      display: block;
    }
  }
}

.colorize-user {
  width: 26px;
  height: 26px;
  cursor: pointer;

  img {
    width: 100%;
  }
}

.input-checkbox {
  width: 17px;
  height: 17px;
  border-color: #A5A7AB;
}

.location {
  margin-top: 10px;
}

@media (max-width: 480px) {
  .calculator__block_car-number {

    .block_car-number {
      box-shadow: -2px 1px 27px -9px rgba(34, 60, 80, 0.6);
      max-width: 380px;
      width: 100%;
    }

    .grid__column--second {
      min-width: 82px;
    }

    .footer__text {
      font-size: 22px;
      line-height: 24px;
    }

    .footer__image {
      width: 30px;
      height: 15px;
      margin-left: 2px;
    }

    .column__text_region-code {
      font-size: 32px;
      line-height: 34px;
    }

    .block__grid {
      max-height: 75px;
      min-height: 75px;
    }




  }
  .holiday {
    .grid__column--first {
      padding: 0 4px;
      max-width: unset;
      min-width: unset;
    }

    .column__text_region-code {
      input {
        max-width: unset;
        font-size: 38px;
        line-height: 43px;
      }
    }

    .footer__text {
      select {
        line-height: 22px;
        font-size: 22px;
      }

      svg {
        right: -3px;
      }
    }

    .holiday-show {

      line-height: 90px;
      max-height: 70px;
      min-height: 70px;


      .upper {
        font-size: 55px;
      }
      .lower {
        font-size: 36px;
      }

    }

    .holiday-inputs {
      flex-direction: column;
    }

    .holiday-input {
      padding: 8px 13px;
      width: unset;
    }

    .grid__column--second {
      padding: 0 5px;
      max-height: 68px;
      max-width: 80px;
    }

    .location-items {
      flex-direction: column;
    }

    .location-content {
      align-items: flex-start;
    }
  }
}
@media (max-width: 400px) {
  .location-items {
    flex-direction: column;
  }
  .location-content {
    align-items: flex-start;
  }

}
@media (max-width: 350px) {
  .calculator__block_car-number {
    .grid__column--first {
      padding-right: 3px;
    }

    .grid__column--second {
      min-width: 70px;
    }
  }
  .holiday {
    .column__text_region-code {
      input {
        font-size: 31px;
      }
    }
  }
}
@media (max-width: 320px) {
  .calculator__block_car-number {




  }
  .holiday .holiday-show .upper {
    font-size: 49px;
  }
  .holiday .holiday-show .lower {
    font-size: 30px;
  }
  .holiday .holiday-show {

    line-height: 80px;
    max-height: 65px;
    min-height: 65px;
  }
  .holiday {
    .column__text_region-code {
      input {

      }
    }
  }
}

.holiday .grid__column--first_region {
  max-width: unset;
  min-width: unset;
}

.toster {
  margin-top: 10px;
}
.blur {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -5;
}
.blur-active {
  filter: blur(3px);
  z-index: 10;
  .blur {
    z-index: 10;
  }
}
.checkers, .segment {
  .colorize-switch {
    &:nth-child(1) {
      margin-top: 0;
    }
  }
}
</style>
